// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"28":"96817a21","382":"f6876435","396":"f69d7278","428":"df3a43e0","772":"8c577454"}[chunkId] + ".css";
};